import * as Models from 'contracts/models';

export const Endpoint = () => `/blog/feed.json`;
export const QueryKey = () => ['blog', 'feed'];
export type Payload = never;
export type Response = Models.Blog.Post[];
